import { Button } from "@mui/material";
import React from "react";

interface IShortcutsOrganizeListHeaderButtonsProps {
    onCancel: () => void;
    onSaveFormat: () => void;
}

const ShortcutsOrganizeListHeaderButtons: React.FC<IShortcutsOrganizeListHeaderButtonsProps> = ({
    onCancel,
    onSaveFormat
}) => {
    return <>
        <Button
            variant="outlined"
            color="primary"
            onClick={onCancel}
        >
            Cancel
        </Button>
        <Button
            variant="contained"
            color="primary"
            onClick={onSaveFormat}
        >
            Save Changes
        </Button>
    </>;
};

export default ShortcutsOrganizeListHeaderButtons;
